import type { Action } from "svelte/action";
import { hasTouchSupport } from "$lib/utils/helpers/hasTouchSupport";
import tippy, { type Props } from 'tippy.js';

type TooltipProps = Partial<Props>;

const tooltip: Action<HTMLElement, TooltipProps> = (node, params) => {
    const theme = 'pnm';
    const trigger = hasTouchSupport() ? 'click' : 'mouseenter focus';

    const tippyInstance = tippy(node, {...params, theme, trigger});

    return {
        destroy: () => tippyInstance.destroy()
    }
}

export {
    tooltip
}

export type {
    TooltipProps
}